module.exports = __webpack_public_path__ + "img/banner2.a55e54b3.png";